import { i18n, Locale } from './i18n.config';

const removeSlashFromTheEnd = (href: string) => href.replace(/\/$/, '');

export const buildUrl = (href: string, lang: Locale) => {
  const isDefaultLang = lang === i18n.defaultLocale;

  return removeSlashFromTheEnd(isDefaultLang ? href : `/${lang}${href}`) || '/';
};
